export default __webpack_public_path__ + "static/media/collapsedHeaderLogo.17b74b27.svg";